<template>
	<div class="department-form">
		<FunctionTitle :title="mainTitle" />
		<CommonFlame :title="subTitle">
			<v-container>
				<v-form ref="form" v-model="valid" lazy-validation>
					<v-alert v-for="(error, i) in errors" :key="i" border="top" color="red lighten-2" dark>
						{{ error }}
					</v-alert>
					<v-row align="center" justify="center">
						<v-col cols="12" sm="8" md="6">
							<v-text-field v-model="name" :rules="[rules.requiredValue]" required label="部門名(必須)" class="my-10" />
							<v-row no-gutters class="my-4" justify="center">
								<v-btn color="secondary" :dark="isValid" :disabled="!isValid" @click="createDepartment()">
									<v-icon>mdi-plus</v-icon>
									登録する
								</v-btn>
							</v-row>
						</v-col>
					</v-row>
				</v-form>
			</v-container>
		</CommonFlame>
	</div>
</template>

<script>
import axios from "axios"
import rules from "../../helper/rules"
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"
import FunctionTitle from "../shared/FunctionTitle.vue"
import CommonFlame from "../shared/CommonFlame.vue"

export default {
	components: {
		FunctionTitle,
		CommonFlame,
	},
	data() {
		return {
			rules: rules,
			name: "",
			valid: false,
			mainTitle: "部門登録",
			subTitle: "部門名入力",
			errors: [],
		}
	},

	methods: {
		createDepartment() {
			if (!this.$refs.form.validate()) return
			const headers = authenticate.setHeader()
			const formData = new FormData()
			formData.append("department[name]", this.name)
			axios
				.post("/erp/v1/departments", formData, { headers })
				.then((res) => {
          this.$store.commit('createDepartment', res.data)
					this.$store.dispatch("setFlash", {
						text: "部門を登録しました",
						type: "notice",
					})
					this.$router.push({ name: "department_index" })
				})
				.catch((err) => {
					let error = errorHandling.errorResponse(err)
					if (Array.isArray(error)) {
						this.errors = error
					}
				})
		},
	},

	computed: {
		isValid() {
			return this.name.length > 0
		},
	},
}
</script>

<style lang="scss" scoped >
.department-form {
	max-width: 800px;
	margin: 0 auto;
}
</style>